import {
  Outlet,
  createFileRoute,
  stripSearchParams,
} from '@tanstack/react-router';

import { ContactsListPanel } from './-components/contacts-list-panel';
import {
  defaultTasksSearch,
  tasksSearchSchema,
} from './-components/tasks-search';

export const Route = createFileRoute('/_dashboard/tasks')({
  validateSearch: tasksSearchSchema,
  search: {
    middlewares: [stripSearchParams(defaultTasksSearch)],
  },
  component: TasksRoute,
});

function TasksRoute() {
  return (
    <div className="flex h-full min-w-0 flex-1 overflow-hidden">
      <ContactsListPanel />
      <Outlet />
    </div>
  );
}
